<template>
  <div class="mx-auto w-full max-w-screen-2xl px-4 py-2 space-y-8 sm:py-6 md:px-6 lg:px-8">
    <RouterLink to="/company-billing"
                class="-mt-4 -mb-1 flex items-center gap-2 text-xs font-bold uppercase text-white underline opacity-60 hover:opacity-100">
      <ArrowLeftIcon class="h-3.5 w-3.5"/>
      <span>Back to Billing</span>
    </RouterLink>
    <BillingEdit :billable-entity-id="billableEntityId"/>
  </div>
</template>

<script setup>
import BillingEdit from "../components/BillingEdit.vue";
import {useAccountStore} from "../stores/AccountStore.js";
import {computed} from "vue";
import {ArrowLeftIcon} from "@heroicons/vue/24/solid/index.js";

const accountStore = useAccountStore();
const billableEntityId = computed(() => accountStore.user?.activeCompany?.billableEntityId);
</script>
